import { crossTypeAllForDropdown,updateStandardCross } from "@/api/cross_type";

const state = {
    crossTypeOptions: null
};

const mutations = {
    GET_ALL_OPTIONS: (state, data) => {
        state.crossTypeOptions = data;
    },
};

const actions = {
    async getAllCrossTypeOptions({ commit }) {
        let res = await crossTypeAllForDropdown();
        if (res) {
            commit("GET_ALL_OPTIONS", res); 
        }
    },
    async updateStandardCross({ commit },id) {
        console.log(id);
        let res = await updateStandardCross({ id: id });
        if (res) {
            return res; 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/cross_type.js